<template>
  <div>
    <cms-cate v-if="cateData == 'CmsCate'"></cms-cate>
    <cms-list v-else-if="cateData == 'CmsList'"></cms-list>
    <text-list v-else-if="cateData == 'TextList'"></text-list>
    <!-- <index-pc v-else-if="cateData == 'IndexPc'"></index-pc> -->
    <course-list
      v-else-if="this.$route.query.id.toString().indexOf('course') > -1"
    ></course-list>
    <cate-single-page v-else-if="cateData == 'CateSinglePage'"></cate-single-page>
    <cms-qualifications-search v-else-if="cateData == 'CmsQualificationsSearch'"></cms-qualifications-search>
    <!-- CateSinglePage -->
  </div>
</template>
<script>
import CmsCate from "@/page/index/cms/CmsCate";
import CmsList from "@/page/index/cms/CmsList";
import TextList from "@/page/index/cms/TextList";
import CourseList from "@/page/index/course/CourseList";
import IndexPc from "@/page/index/IndexPc";
import CateSinglePage from "@/page/index/cms/CateSinglePage";
import CmsQualificationsSearch from "@/page/index/cms/cmsQualificationsSearch";

export default {
  name: "Cate",
  data() {
    return {
      cateData: "",
      queryid: this.$route.query.id|0,
    };
  },
  mounted() {
    // console.log(this.$store.commit('increment',{id:123}));
    this.getCateTargetFun();
  },
  methods: {
    // 根据id  映射首页的cate
    //id ==92  cmslist  新闻资讯页面
    //id ==96  cmscate  页面
    //id ==99  TextList  页面
    //id ==106  CourseList  页面
    getCateTargetFun() {
      var that = this;
      if (this.$route.query.id.toString().indexOf("course") > -1) {
        that.cateData = "";
        return;
      }
      //处理首页的跳转问题
      if(this.$route.name=='IndexPc'){
        this.queryid = 113;
      }
      that.$api.get(
        "/api/cms/cateListItem",
        {
          id: this.queryid,
        },
        (res) => {
          if (res.data[0]) {
            that.cateData = res.data[0].tpl;
            if (that.cateData=='IndexPc') {
              this.$router.push({name:"IndexPc"})
              return;
            }
          }
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
  },
  watch: {
    $route: {
      handler() {
        this.queryid = this.$route.query.id;
        this.getCateTargetFun();
      },
      deep: true,
    },
  },
  components: {
    CmsCate,
    CmsList,
    TextList,
    CourseList,
    IndexPc,
    CateSinglePage,
    CmsQualificationsSearch
  },
};
</script>



// WEBPACK FOOTER //
// cate.vue?31ad20e4